import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { Input, Select, Option, Checkbox, Switch, Calendar} from 'element-ui';
import  VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";
import axios from "axios";
import weui from 'weui.js';
import 'weui';
import qs from 'qs';
import $ from 'jquery';
// import Mui from 'vue-awesome-mui';
import TextTips from './components/TextTips.vue';
import PageLong from './components/PageLong.vue';
import Errosage from './components/Errosage.vue';
import Succtips from './components/Succtips.vue';
import botgaion from './components/botgaion.vue';


Vue.config.productionTip = false;
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(Switch);
Vue.use(Calendar);
Vue.use(VueAwesomeSwiper);
Swiper2.use([Autoplay, Navigation, Pagination]);
Vue.prototype.$axios = axios;
Vue.prototype.$weui = weui;
Vue.prototype.$qs = qs;
Vue.prototype.$ = $;
// Vue.use(Mui);
Vue.component('TextTips', TextTips);
Vue.component('PageLong', PageLong);
Vue.component('Errosage', Errosage);
Vue.component('Succtips', Succtips);
Vue.component('botgaion', botgaion);


// /*第一层if判断生产环境和开发环境*/
if (process.env.NODE_ENV === 'production') {
  /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
  if (process.env.VUE_APP_FLAG === 'pro') {
      //production 生产环境
      axios.defaults.baseURL = 'https://wd.obraopay.com/obly/';

  } else {
      //test 测试环境
      axios.defaults.baseURL = 'https://wd.obraopay.com/obly/';

  }
} else {
  //dev 开发环境
  axios.defaults.baseURL = 'https://wd.obraopay.com/obly/';
}


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
